import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'active',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserStatus: (state, action) => {
      state.status = action.payload;
    },
  },
});

export const { setUserStatus } = userSlice.actions;

export const userReducer = userSlice.reducer;
